import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores/hooks/hooks';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import ActionsTable from './ActionsTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const ResellerActions: FC = observer(() => {
  const [isLoading, setIsLoading] = useState(true);
  const {
    resellersStore: { selectedRowsSystems, selectedGrowerId },
    actionsStore,
  } = useStores();

  useEffect(() => {
    setIsLoading(true);
    const controller = new AbortController();
    actionsStore
      .getActions(selectedGrowerId, controller)
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });

    return () => {
      actionsStore.clearActions();
      controller.abort();
    };
  }, [actionsStore, selectedGrowerId]);

  return (
    <Container>
      <ActionsTable isLoading={isLoading} />
    </Container>
  );
});

export default ResellerActions;
